import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIAlert from '../alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIFireAlarm(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIAlert, Object.assign({}, rest, {
    className: classNames('private-alert--system-wide', className)
  }));
}
UIFireAlarm.propTypes = Object.assign({}, UIAlert.propTypes, {
  type: PropTypes.oneOf(['danger', 'info', 'warning']).isRequired
});
UIFireAlarm.defaultProps = Object.assign({}, UIAlert.defaultProps, {
  type: 'warning'
});
UIFireAlarm.displayName = 'UIFireAlarm';